var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sw--height-full sw-dms--bg-grey-96" }, [
    _vm.isVizProcessing
      ? _c(
          "div",
          {
            staticClass:
              "sw--position-relative sw--height-full sw-grid-flex__cell sw--height-full"
          },
          [
            _c("div", {
              staticClass:
                "sw-loading-animation sw--font-size-18 sw--position-absolute sw--position-fill"
            })
          ]
        )
      : _vm.isVizAvailable && _vm.glbPath
      ? _c(
          "div",
          {
            staticClass:
              "printability-center-viz sw-grid-flex--tab sw-grid-flex--justify-center--tab sw--height-full",
            attrs: { id: "boundingBoxViz" }
          },
          [
            _c("sw-viewer", {
              attrs: {
                src: _vm.glbPath,
                viewer: "model-viewer",
                "up-axis": "Y",
                rotation: "0 1 0 -0.349",
                "orbit-mode": "turntable",
                material: "default",
                "viewer-attributes":
                  "camera-orbit=auto 75deg auto&shadow-intensity=0.5&shadow-softness=0.6&field-of-view=15deg",
                "show-grid": "false",
                "show-axes": "false"
              }
            }),
            _vm._v(" "),
            _c("img", {
              staticClass:
                "sw--display-none sw--display-block--tab sw--height-auto sw--width-auto sw--max-height-250px--tab",
              attrs: { src: _vm.pictureUrl }
            }),
            _vm._v(" "),
            _c("script", {
              attrs: {
                type: "module",
                src: "/rrstatic/javascript/sw-viewer.js"
              }
            })
          ],
          1
        )
      : _vm.isVizAvailable && _vm.aoptPath
      ? _c(
          "div",
          {
            staticClass:
              "printability-center-viz sw-grid-flex--tab sw-grid-flex--justify-center--tab sw--height-full",
            attrs: { id: "boundingBoxViz" }
          },
          [
            _c("iframe", {
              staticClass:
                "printability-center-bounding-box-iframe sw--display-none--tab",
              attrs: {
                id:
                  "automated-printability-checks-asset-aopt-bounding-box-iframe",
                scrolling: "no",
                frameborder: "0",
                src: _vm.aoptPath,
                "data-sw-3d-tools-viz-iframe": ""
              }
            }),
            _vm._v(" "),
            _c("img", {
              staticClass:
                "sw--display-none sw--display-block--tab sw--height-auto sw--width-auto sw--max-height-250px--tab",
              attrs: { src: _vm.pictureUrl }
            })
          ]
        )
      : _vm.isVizUnavailable
      ? _c(
          "div",
          {
            staticClass:
              "sw--height-full sw-grid-flex sw-grid-flex--align-center sw-grid-flex--justify-center sw--height-full"
          },
          [
            _c("div", { staticClass: "sw-dms--text-light" }, [
              _vm._v("Visualization Not Currently Available.")
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }